import angular from 'angular';

(function() {
    'use strict';

    var core = angular.module('app.core');

    // ------------------
    // Configuration de la gestion de la sécurité sur chaque changement de route
    // ------------------
    core.run(authActions);

    authActions.$inject = ['$rootScope', '$state', '$translate', 'AUTH_EVENTS', 'toastr'];

    function authActions($rootScope, $state, $translate, AUTH_EVENTS, toastr) {
        // Message d'erreur sur les actions non autorisées
        $rootScope.$on(AUTH_EVENTS.notAuthorized, function() {
            toastr.error($translate.instant('AUTH_TITLE'), $translate.instant('AUTH_UNALLOWED'));
        });
    }

    // ------------------
    // Configuration de la langue pour les grilles
    // ------------------
    core.run(gridI18n);

    gridI18n.$inject = ['i18nService'];

    function gridI18n(i18nService) {
        i18nService.setCurrentLang('fr');
    }

    // ------------------
    // Configuration du calendrier
    // ------------------
    core.run(datepicker);

    datepicker.$inject = ['$datepicker'];

    function datepicker($datepicker) {
        angular.extend($datepicker.defaults, {
            startWeek: 1 // lundi
        });
    }

    // --------------------------------------------------
    // Configuration du délai de session
    // --------------------------------------------------
    core.run(startIdle);

    startIdle.$inject = ['$rootScope', 'Idle', 'AuthSvc', 'AUTH_EVENTS', '$sessionStorage', 'Title'];

    function startIdle($rootScope, Idle, AuthSvc, AUTH_EVENTS, $sessionStorage, Title) {
        $rootScope.$on(AUTH_EVENTS.loginSuccess, function() {
            // lancer le watch Idle
            Idle.watch();
        });

        $rootScope.$on(AUTH_EVENTS.logoutSuccess, function() {
            // Arrêter le watch Idle
            Idle.unwatch();
            Title.restore();
            $sessionStorage.$reset();
        });

        $rootScope.$on('IdleTimeout', function() {
            /* Logout user */
            AuthSvc.logout().then(function() {
                $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
            });
        });

        $rootScope.$on('Keepalive', function() {
            AuthSvc.ping().then(
                function() {},
                function(/*error*/) {
                    //logout du user courant
                    AuthSvc.logout().then(function() {
                        $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
                    });
                }
            );
        });
    }

    // --------------------------------------------------
    // Configuration de la fenêtre de confirmation
    // --------------------------------------------------
    core.run(confirmConfig);

    confirmConfig.$inject = ['$confirmModalDefaults'];
    function confirmConfig($confirmModalDefaults) {
        $confirmModalDefaults.templateUrl = require('../layouts/confirm.html');
    }

    // --------------------------------------------------
    // Configuration de la transition vers la liste des lots pour recharger les résultats
    // --------------------------------------------------
    core.run(reloadBatchResults);

    reloadBatchResults.$inject = ['$transitions'];
    function reloadBatchResults($transitions) {
        $transitions.onStart({ to: 'batches' }, function(trans) {
            // Lorsque l'on vient des détail, on veut relancer la recherche avec les critères précédents
            trans.addResolvable({
                token: 'loadFromHisto',
                resolveFn: function() {
                    return trans.from().name === 'batch_details' || trans.from().name === 'batches';
                }
            });
        });
    }
    // --------------------------------------------------
    // initialisation du $sessionStorage dans PrincipalSvc lorsque les critères de sauvegarde des données ne sont pas là. */
    // --------------------------------------------------
    core.run(initPrincipalStorage);

    initPrincipalStorage.$inject = ['$transitions', 'PrincipalSvc'];
    function initPrincipalStorage($transitions, PrincipalSvc) {
        $transitions.onSuccess({ to: 'do' }, function(trans) {
            if (
                !trans.from().name ||
                !(trans.from().name.indexOf('app.principal.consult') > -1 || trans.from().name === 'do')
            ) {
                PrincipalSvc.initPrincipalListStorage();
            }
        });
    }
})();
